
















import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-list-toolbar',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  $refs!: {
    catalogToolbar: Element;
  }

  @Prop({required: true}) readonly dataSource: string;
  @Prop({
    default: () => {
      return []
    }
  }) readonly subCategories: Array<object>;
  @Prop() readonly categoryName: string;
  @Prop({default: 'top'}) readonly type: string;

  private observer: IntersectionObserver | null = null;
  private isVisible: boolean = false;

  private get totalProductCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }

  private get activeFilters(): Array<object> {
    return this.$store.getters[`${this.dataSource}/activeFilters`];
  }

  private removeFilters(): void {
    this.$store.dispatch(`${this.dataSource}/fetchCatalog`, {filters: []});
  }

  private created(): void {
    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: null,
      rootMargin: '-110px',
      threshold: 0.2
    });
  }

  private onElementObserved(entries): void {
    this.isVisible = entries[0].isIntersecting;
  }

  private mounted(): void {
    this.observer.observe(this.$refs['catalogToolbar']);
  }
}
